<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" label-width="90px">
          <el-row class="ledger-search-toggle-row" :gutter="24">
            <el-col :span="24" class="ledger-search-toggle-col">
              <el-button type="text" class="ledger-search-toggle-btn" @click="searchFiltersExpanded = !searchFiltersExpanded">
                <i :class="searchFiltersExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                {{ searchFiltersExpanded ? '收起筛选条件' : '展开筛选条件' }}
              </el-button>
            </el-col>
          </el-row>

          <div v-show="searchFiltersExpanded" class="ledger-search-filters">
            <el-row :gutter="24" type="flex">
              <el-col :span="5">
                <el-form-item label="委托单编号" prop="entrustNum">
                  <el-input v-model="queryParams.entrustNum" placeholder="请输入委托单编号" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="检测人" prop="testEmployeeName">
                  <el-input v-model="queryParams.testEmployeeName" placeholder="请输入检测人" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="设备名称" prop="eqpTempName">
                  <el-input v-model="queryParams.eqpTempName" placeholder="请输入设备名称" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="客户名称" prop="compNames">
                  <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleQuery" />
                  <CustomerDetails v-model="queryParams.compNames" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="识别码" prop="oidno">
                  <el-input v-model="queryParams.oidno" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" type="flex">
              <el-col :span="5">
                <el-form-item label="使用单位" prop="usingUnit">
                  <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="小区名称" prop="houseName">
                  <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="检测日期" prop="testDateRange">
                  <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  clearable @change="handleQuery" style="width:100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="设备代码" prop="eqpStationCod">
                  <el-input v-model="queryParams.eqpStationCod" placeholder="请输入设备代码" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="产品编号" prop="factoryCod">
                  <el-input v-model="queryParams.factoryCod" placeholder="请输入产品编号" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="有无整改项" prop="queryType">
                <el-select v-model="queryParams.queryType" placeholder="请选择有无整改项" clearable @keyup.enter.native="handleQuery">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="有" :value="0"></el-option>
                  <el-option label="无" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @resetQuery="resetQuery" @handleSignClick="handleSignClick" @BatchReturn="BatchReturn"
                                     @handleExport="handleExport" />
          </div>
        </el-form>

        <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading" row-key="id"
                  height="500" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" fixed="left" align="left"></el-table-column>
          <el-table-column type="index" label="序号" width="55" fixed="left" align="left"></el-table-column>
          <el-table-column label="有无签名" align="left" prop="signStatus" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.signStatus == 1 ? 'success' : 'danger'">
                {{ scope.row.signStatus == 1 ? '有' : '无' }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- <el-table-column label="检测日期" align="left" prop="testDateRange" width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column> -->
          <el-table-column label="检测日期" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
          <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="识别码" align="left" prop="oidno" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="产品编号" align="left" prop="factoryCod" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="检测人" align="left" prop="testEmployeeName" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备名称" align="left" prop="eqpTempName" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备代码" align="left" prop="eqpStationCod" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="内部编号" align="left" prop="eqpInnerCod" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="小区名称" align="left" prop="houseName" min-width="140" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column label="有无整改项" align="left" prop="memoState" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.memoState == 0 ? 'success' : 'danger'">
                {{ scope.row.memoState == 2 ? '无' : '有' }}
              </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column label="委托单编号" align="left" prop="entrustNum" min-width="260" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="left" width="420" fixed="right">
            <template slot-scope="scope">
              <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleRectificationDetail="handleRectificationDetail(scope.row)"
                                   @handleMemoDetail="handleMemoDetail(scope.row)" @handleEquipmentInfo="handleEquipmentInfo(scope.row)" @handlePDF="handlePDF(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                       :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 整改详情弹出层 -->
    <Rectification ref="rectification" @refresh="getList" />

    <!-- 二维码弹出层 -->
    <el-dialog title="签名二维码" :visible.sync="qrDialogVisible" width="360px" :close-on-click-modal="false">
      <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
        <img v-if="qrImageUrl" :src="qrImageUrl" alt="二维码" style="width:240px;height:240px;border:1px solid #eee;padding:4px;border-radius:4px;" />
        <div v-else style="height:240px;display:flex;align-items:center;justify-content:center;color:#999;">正在生成二维码...</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="qrDialogVisible = false">关 闭</el-button> -->
        <!-- <el-button type="primary" :disabled="!qrImageUrl" @click="downloadQr">下 载</el-button> -->
      </span>
    </el-dialog>

    <!-- PDF预览弹窗 -->
    <el-dialog title="PDF预览" :visible.sync="pdfPreviewVisible" width="90%" :close-on-click-modal="false">
      <PdfImgViewer v-if="pdfPreviewVisible && pdfFileName" :fileName="pdfFileName" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <EquipmentConfirmDialog ref="equipmentConfirmDialog" />
  </div>
</template>

<script>
import Rectification from './rectification.vue';
import EquipmentConfirmDialog from '../OriginalManagement/EquipmentConfirmDialog.vue';
import { queryRectificationDetailList, exportRectificationDetailList, previewTestDataPdf, batchBackToDataEntry } from '@/api/contract/contract';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';

export default {
  name: 'RectificationItem',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    Rectification,
    PdfImgViewer,
    EquipmentConfirmDialog
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 筛选条件区域展开（收起后表格区域变高）
      searchFiltersExpanded: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 勾选的数据
      multipleSelection: [],
      // 二维码弹窗
      qrDialogVisible: false,
      // 二维码图片地址
      qrImageUrl: '',
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        entrustNum: undefined,
        testEmployeeName: undefined,
        eqpTempName: undefined,
        eqpStationCod: undefined,
        eqpInnerCod: undefined,
        compNames: undefined,
        usingUnit: undefined,
        houseName: undefined,
        testDateRange: undefined,
        queryType: 0,
        oidno: ''
      },
      // PDF预览相关
      pdfPreviewVisible: false,
      pdfFileName: ''
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 查询列表
    getList () {
      this.loading = true;
      const payload = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize,
        entrustNum: this.queryParams.entrustNum,
        testEmployeeName: this.queryParams.testEmployeeName,
        eqpTempName: this.queryParams.eqpTempName,
        eqpStationCod: this.queryParams.eqpStationCod,
        eqpInnerCod: this.queryParams.eqpInnerCod,
        compNames: this.queryParams.compNames,
        usingUnit: this.queryParams.usingUnit,
        houseName: this.queryParams.houseName,
        testDateRange: this.queryParams.testDateRange,
        oidno: this.queryParams.oidno,
        factoryCod: this.queryParams.factoryCod,
        queryType: this.queryParams.queryType,
      };

      queryRectificationDetailList(payload)
        .then(res => {
          this.loading = false;
          if (res && res.retCode === 'ok') {
            const pageData = res.additionalData || res.data || {};
            const {
              dataList = [],
              curPage = this.queryParams.currPage,
              pageSize = this.queryParams.pageSize,
              totalRowNum = 0
            } = pageData;
            this.tableData = dataList.map((item, index) => {
              return {
                ...item,
                id: item.id || index,
                entrustNum: item.entrustNum || item.entrutsNum || '',
                testEmployeeName: item.testEmployeeName || '',
                eqpTempName: item.eqpTempName || '',
                eqpStationCod: item.eqpStationCod || '',
                eqpInnerCod: item.eqpInnerCod || '',
                compName: item.compName || '',
                usingUnit: item.usingUnit || '',
                houseName: item.houseName || '',
                testEmployeeDate: item.testEmployeeDate || ''
              };
            });
            this.queryParams.currPage = curPage;
            this.queryParams.pageSize = pageSize;
            this.total = totalRowNum;
          } else {
            this.$message.error((res && res.retMsg) || '获取整改记录列表失败');
          }
        })
        .catch(error => {
          console.error('获取整改记录列表失败:', error);
          this.loading = false;
          this.$message.error('获取整改记录列表失败');
        });
    },
    // 搜索按钮
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    handleExport () {
      this.$message.info('正在导出...')
      const payload = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize,
        entrustNum: this.queryParams.entrustNum,
        testEmployeeName: this.queryParams.testEmployeeName,
        eqpTempName: this.queryParams.eqpTempName,
        eqpStationCod: this.queryParams.eqpStationCod,
        eqpInnerCod: this.queryParams.eqpInnerCod,
        compNames: this.queryParams.compNames,
        usingUnit: this.queryParams.usingUnit,
        houseName: this.queryParams.houseName,
        testDateRange: this.queryParams.testDateRange,
        oidno: this.queryParams.oidno,
        factoryCod: this.queryParams.factoryCod,
        queryType: this.queryParams.queryType
      }
      exportRectificationDetailList(payload).then(response => {
        let blob
        if (response instanceof Blob) {
          blob = response
        } else if (response && response.data instanceof Blob) {
          blob = response.data
        } else {
          blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
        }
        if (blob.type && blob.type.includes('application/json')) {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result)
              this.$message.error(errorData.retMsg || errorData.message || '导出失败')
            } catch (e) {
              this.$message.error('导出失败')
            }
          }
          reader.readAsText(blob)
          return
        }
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `整改项列表_${new Date().getTime()}.xlsx`
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(err => {
        this.$message.error(err.message || '导出失败')
      })
    },
    // 重置查询
    resetQuery () {
      this.queryParams = {
        currPage: 1,
        pageSize: 200,
        entrustNum: undefined,
        testEmployeeName: undefined,
        eqpTempName: undefined,
        eqpStationCod: undefined,
        eqpInnerCod: undefined,
        compNames: undefined,
        usingUnit: undefined,
        houseName: undefined,
        testDateRange: undefined,
        queryType: 0
      };
      this.getList();
    },
    // 整改详情按钮
    handleRectificationDetail (row) {
      this.$refs.rectification.openDialog(row,{source: 'rectificationItem'});
    },
    // 表格勾选变更
    handleSelectionChange (val) {
      this.multipleSelection = Array.isArray(val) ? val : [];
    },
    // 点击签名
    handleSignClick () {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选需要签名的记录');
        return;
      }
      // 收集勾选的 entrustNum
      const entrustNums = this.multipleSelection
        .map(item => item.entrustNum)
        .filter(v => !!v);
      if (entrustNums.length === 0) {
        this.$message.warning('勾选的数据缺少委托单编号');
        return;
      }
      // 构建最终跳转地址
      const finalUrl = this.buildSignUrl(entrustNums);
      // 使用在线服务生成二维码图片
      this.qrImageUrl = this.buildQrImageUrl(finalUrl);
      this.qrDialogVisible = true;
    },
    // 构建签名链接：https://www.tljcgroup.cn?entrustNums=WT1%2CWT2
    buildSignUrl (entrustNums) {
      const joined = entrustNums.join(',');
      const encoded = encodeURIComponent(joined); // 逗号会被编码为 %2C
      return `https://www.tljcgroup.cn?entrustNums=${encoded}`;
    },
    // 生成二维码图片地址（使用在线二维码服务）
    buildQrImageUrl (text) {
      const encodedData = encodeURIComponent(text);
      // 240x240 尺寸二维码
      return `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodedData}`;
    },

    // 预览文件
    handleMemoDetail (row) {
      if (!row.memoFileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.pdfFileName = row.memoFileUUID;
      this.pdfPreviewVisible = true;
    },
    // 批量退回
    BatchReturn () {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选需要退回的记录');
        return;
      }

      // 勾选记录中只要存在 memoState 不为 0，则不可退回
      const hasInvalidMemoState = this.multipleSelection.some(item => Number(item.memoState) !== 0);
      if (hasInvalidMemoState) {
        this.$message.warning('无整改项的无法退回');
        return;
      }

      const entrustNumList = this.multipleSelection
        .map(item => item.entrustNum)
        .filter(v => !!v);
      if (entrustNumList.length === 0) {
        this.$message.warning('勾选的数据缺少委托单编号');
        return;
      }

      this.loading = true;
      batchBackToDataEntry({ entrustNumList })
        .then(res => {
          this.loading = false;
          if (res && (res.code === 20011 || res.retCode === 'ok')) {
            this.$message.success((res && (res.message || res.retMsg)) || '批量退回成功');
            this.getList();
            return;
          }
          this.$message.error((res && (res.message || res.retMsg)) || '批量退回失败');
        })
        .catch(error => {
          this.loading = false;
          console.error('批量退回失败:', error);
          this.$message.error('批量退回失败');
        });
    },
    // 设备信息
    handleEquipmentInfo (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$refs.equipmentConfirmDialog && this.$refs.equipmentConfirmDialog.show(row, 'view');
    },
    // PDF
    handlePDF (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      // 默认打开原始记录（type: 1）
      this.callPreviewAPI(row.entrustNum, 1);
    },
    // 调用预览PDF的API
    callPreviewAPI (entrustNum, type) {
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        loading.close();

        if (response && response.retCode === 'ok' && response.additionalData) {
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },
    // 下载二维码
    downloadQr () {
      if (!this.qrImageUrl) return;
      const link = document.createElement('a');
      link.href = this.qrImageUrl;
      link.download = '签名二维码.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    /**
* 获取禁用的按钮列表
* @param {Object} row - 当前行数据
* @returns {Array} 禁用的按钮名称数组
*/
    getDisabledButtons (row) {
      if (row.memoState != 1 && row.memoState != 0) {
        // this.$message.warning('备忘录状态为未完成，无法查看整改详情');
        return ['handleRectificationDetail']
      }
      return []
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.ledger-search-toggle-row {
  margin-bottom: 4px;
}

.ledger-search-toggle-col {
  text-align: right;
  line-height: 1;
}

.ledger-search-toggle-btn {
  padding: 0 4px;
  font-size: 13px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>

